import { BIM360Issue, BIM360IssueStatus, BIM360IssueCustomAttribute } from '../BIM360Issue';
import { FrontendBIM360Issue } from '../frontend/FrontendBIM360Issue';
export class BackendBIM360IssueV2 extends BIM360Issue
{

    public async saveChanges()
    {

    }

    public static fromAutodeskJSON(json: any): BackendBIM360IssueV2
    {
        let issue = new BackendBIM360IssueV2();
        issue.id = json.displayId;
        issue.forgeId = json.id;
        issue.description = json.description;
        issue.permittedStatuses = json.permittedStatuses;
        issue.permittedAttributes = json.permittedAttributes;
        issue.status = json.status;
        issue.title = json.title;
        issue.issueTypeId = json.issueTypeId;
        issue.issueSubtypeId = json.issueSubtypeId;
        issue.assignedTo = json.assignedTo;
        issue.assignedToType = json.assignedToType;
        issue.location = json.locationId;
        issue.locationDescription = json.locationDetails;
        issue.dueDate = json.dueDate;
        issue.rootCauseId = json.rootCauseId;
        issue.customAttributes = json.customAttributes.map(data => BackendBIM360IssueCustomAttributeV2.fromAutodeskJSON(data))
        return issue;
    }

    public static toAutodeskJSON(json: FrontendBIM360Issue): any
    {
        return {
            status: json.status || undefined,
            title: json.title || undefined,
            description: json.description || undefined,
            assignedTo: json.assignedTo || undefined,
            assignedToType: json.assignedToType || undefined,
            dueDate: json.dueDateString || undefined,
            issueSubtypeId: json.issueSubtypeId || undefined,
            // issueTypeId: json.issueTypeId || undefined, // readonly
            locationDetails: json.locationDescription || undefined,
            rootCauseId: json.rootCauseId || undefined,
            customAttributes: json.customAttributes.map(data => BackendBIM360IssueCustomAttributeV2.toAutodeskJSON(data)) || undefined,

        }
    }
}

export class BackendBIM360IssueCustomAttributeV2 extends  BIM360IssueCustomAttribute {
    public static toAutodeskJSON(attr: BackendBIM360IssueCustomAttributeV2): any
    {
        return {
            attributeDefinitionId: attr.attributeDefinitionId,
            value: attr.value
        }
    }

    public static fromAutodeskJSON(json: any): BackendBIM360IssueCustomAttributeV2
    {
        const attr =  new BackendBIM360IssueCustomAttributeV2;
        attr.attributeDefinitionId = json.attributeDefinitionId || undefined;
        attr.title = json.title || undefined;
        attr.type = json.type || undefined;
        attr.value = json.value || undefined;
        return attr;
    }
}
